import Vue from 'vue'

export default {
    UPDATE_ARTICLES (state, value) {
        Vue.set(state, 'articles', value);
    },
  SET_ARTICLES (state, value) {
        this.commit('UPDATE_ARTICLES', value);
    },
    SET_SELECTED_ARTICLE (state,  value ) {
      Vue.set(state, 'selectedArticle', value);
    },
}



// WEBPACK FOOTER //
// ./src/store/modules/articles/mutations.js